<template>
    <div class="conversation-step d-flex flex-md-row flex-column justify-content-md-between align-items-md-center">
        <div data-name="description-box">
            <p>{{ data.step }}</p>
            <p data-type="main-text">{{ data.title }}</p>
            <p data-type="main-text">{{ data.desc }}</p>
        </div>
        <div data-name="video-container">
            <video :src="data.videoUrl" autoplay muted loop playsinline></video>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/Theme/Icon'
export default {
    name: 'Step',
    components: {
        Icon
    },
    props: {
        data: Object
    }
}
</script>

<style scoped lang="scss">
$mob_title: 18px;
$mob_desc: 16px;
$mob_mt: 40px;
$mob_desc_lineheight: 24px;
.conversation-step {
    margin-top: 120px;
    &:nth-child(2n +1) {
        div {
            &:first-child {
                order: 2;
                padding-left: 40px;
            }
            &:last-child {
                order: 1;
                padding-right: 0;
            }
        }
    }
    div {
        &[data-name="video-container"] {
            border-radius: 16px;
            border: 1.5px solid #727CF5;
            padding: 1px;
            video {
                border-radius: 16px;
                width: 100%;
            }
        }
        &[data-name="description-box"] {
            max-width: 440px;
        }
        &:first-child {
            p {
                &:first-child {
                    font-size: 18px;
                    color: #727CF5;
                    font-family: 'EinaBold';
                }
                &:nth-child(2) {
                    line-height: 35px;
                    font-size: 27px;
                    font-weight: 700;
                }
                &:nth-child(3) {
                    line-height: 28px;
                    font-size: 18px;
                    font-weight: 400;
                    margin-top: 8px;
                }
            }
        }
    }
}
@media (max-width: 767px) {
    .conversation-step {
        margin-top: $mob_mt;
        &:nth-child(2n +1) {
            div {
                &:first-child {
                    order: 1;
                    padding: 0;
                }
                &:last-child {
                    padding: 0;
                    order: 2;
                }
            }
        }
        div {
            &:first-child {
                max-width: 440px;
                margin-bottom: 16px;
                p {
                    &:first-child {
                        font-size: $mob_desc;
                    }
                    &:nth-child(2) {
                        font-size: $mob_title;
                        line-height: $mob_desc_lineheight;
                    }
                    &:nth-child(3) {
                        line-height: $mob_desc_lineheight;
                        font-size: $mob_desc;
                    }
                }
            }
        }
    }
}
</style>